import { memo, useCallback } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useFillTemplates from 'hooks/useFillTemplates';
import { fillTemplatesSelectors } from 'features/fillTemplates';

const FillTemplatesAutocomplete = ({ value, error, helperText, onChange }) => {
  const { getFillTemplates } = useFillTemplates();
  const { data, pagination } = useCustomSelector(fillTemplatesSelectors.getFillTemplatesData);
  const fetching = useCustomSelector(fillTemplatesSelectors.fillTemplatesIsFetching);

  const handleChange = (_, formattedValue) => onChange({ value: formattedValue?.id, formattedValue, error: '' });;
  const isOptionEqualToValue = (o, v) => o.id === v.id;
  const fetchFillTemplates = useCallback(offset => {
    getFillTemplates({ offset })
  }, [getFillTemplates]);
  const handleScroll = ({ target: { scrollTop, scrollHeight, clientHeight } }) => {
    const { limit, offset, count, total_count } = pagination;

    if (scrollTop + clientHeight + 65 >= scrollHeight && offset + count < total_count && !fetching) {
      fetchFillTemplates(limit + offset);
    }
  };
  const renderOption = (props, option) => (
    <li {...props} key={option?.id}>
        {option.template?.name}
    </li>
  );

  return (
    <Autocomplete
      value={value}
      onChange={handleChange}
      id="fillTemplatesList"
      options={data}
      getOptionLabel={o => o?.template?.name}
      renderOption={renderOption}
      isOptionEqualToValue={isOptionEqualToValue}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      ListboxProps={{ onScroll: handleScroll, role: 'list-box' }}
      fullWidth
      renderInput={params => <TextField {...params} label='Template' error={error} helperText={helperText} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FillTemplatesAutocomplete {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);